/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProducersInputs */

const en_producers = /** @type {(inputs: ProducersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producers`)
};

const es_producers = /** @type {(inputs: ProducersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productores`)
};

/**
* | output |
* | --- |
* | "Producers" |
*
* @param {ProducersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const producers = /** @type {((inputs?: ProducersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProducersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_producers(inputs)
	return es_producers(inputs)
});